import type { FaireProductEntity } from "../../entity_types/product";

export const p_rccs8zrjcx: FaireProductEntity = {
  token: "p_rccs8zrjcx",
  type: "product",
  name: "C.C Kids Double Pom Pom Beanie",
  brandToken: "b_926lzrw9gt",
  brandName: "Hana",
  imageUrl:
    "https://cdn.faire.com/fastly/f66bc3e7fa0472d1d545ed209176254000bc16d7dde96aa43a2bebfc1a242ce6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/86e8bf8b39f6500d026ebb950096d598dd989aa874c985dba934da3e457155e1.jpeg",
    "https://cdn.faire.com/fastly/7ffbd53b039373a3be3bad892b6b3f07a009f57233c13da813db2ac864ee30a9.jpeg",
    "https://cdn.faire.com/fastly/a94b980af562a8ec3447d6cd4771089da5971aed5a21bba5bb9447286360f440.jpeg",
    "https://cdn.faire.com/fastly/221e46c561300206022873ca698ac9e4ee7674932fea74c5d6e9a5e8e750f957.jpeg",
    "https://cdn.faire.com/fastly/77454f796470ba4918531114d93fef7ca02f9707bff78ca12f5e4fe26ebecbc9.jpeg",
    "https://cdn.faire.com/fastly/b1ceaaa2bd0ec277621dcbe0642d3986a422fafc988e4d71b4f7b7e9f30dfc71.jpeg",
    "https://cdn.faire.com/fastly/7ecc51244e3619e5127b9565d464d3fe6101d3787ddacec0cb2a1f4623d1dfa6.jpeg",
    "https://cdn.faire.com/fastly/6151ec6ba3eee82d8c45aa1c866979cb67ffdc1e44e8c4081f947569719ec14c.jpeg",
    "https://cdn.faire.com/fastly/2df104a6af2613a6cadbb675e1ee80b1dfa7135303387f58493ed533e0a4427e.jpeg",
    "https://cdn.faire.com/fastly/8783a98f663b689e1bd081992e0e30e10e67f13f61796ff5e3e3561e176e3959.jpeg",
    "https://cdn.faire.com/fastly/63a6398a44afee0ded56744c770960ed7c4e7a04b0c4f5e1b90035b677008aa3.jpeg",
    "https://cdn.faire.com/fastly/9879b762721e233118e11c7318dcf6c7286201a8911b6da5c9378fbcbbd87b1c.jpeg",
    "https://cdn.faire.com/fastly/8c042eee6ba131aad43b50ddee1f5842ea2d515848b575f75fd279ce6a401151.jpeg",
    "https://cdn.faire.com/fastly/67ca6782dda51ec10eca267c871e50008478a47e8fa2a0c2af4956ee8d9fd20b.jpeg",
    "https://cdn.faire.com/fastly/0fd4dc0ed3d73a6eb7f84608f20a740cf87ba092ec734d2697f64d0de59b82b8.jpeg",
    "https://cdn.faire.com/fastly/e84153d563f363abfb8bcfaf2cabed3a44a90f6723239de684e43d707e876bcc.jpeg",
    "https://cdn.faire.com/fastly/18df4bab26dac9b602e85d52ff232d141deeda27afb8852d1ab1827d4856fb92.jpeg",
    "https://cdn.faire.com/fastly/c81a3d5768510709bd3600df3366f8273e602ad973e558c81bc2fc0cc9fc10f0.jpeg",
    "https://cdn.faire.com/fastly/0f351cac39cf316a466bc958206b413562bcae3b7c2d1d5923c92348ab892748.jpeg",
    "https://cdn.faire.com/fastly/01cd35dcb686e6b7e692331eda901c277a81d1c30ac5b6c04b754449071dc04f.jpeg",
    "https://cdn.faire.com/fastly/55030fa7cc728e632e8480baf101885cf87d2f6fc803d24f1b3feb7d95846bc2.jpeg",
  ],
  priceDollars: 6.75,
  description:
    "C.C Kids Double Pom Pom Beanie\nFit 2-7 years old\n100% Acrylic\nMade in China",
  tags: [],
  msrpDollars: 13.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:20.368Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
